import gql from 'graphql-tag';

export default gql`
mutation deletePageTagsByPageId($pageId: Int!) {
  delete_pages_tags(where: {page_id: {_eq: $pageId}}) {
    affected_rows
  }
}
`;
